// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3679":"649dee1e62c57602","7412":"bfed1d886091ab59","9133":"134e2bcfb436a8b2"}[chunkId] + ".css";
};